import { render, staticRenderFns } from "./LabObjectivesContent.vue?vue&type=template&id=49ab0b6a"
import script from "./LabObjectivesContent.vue?vue&type=script&lang=js"
export * from "./LabObjectivesContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports